const HEADER_NAME = 'x-spotim-spotid';
var injectedSpotId = undefined;

export function setSpotIdInjectorValue(id) {
  injectedSpotId = id;
}

export function getSpotIdInjectorValue() {
  return injectedSpotId;
}

function createRequestInterceptor(spotId = undefined) {
  return function requestInterceptor(request) {
    if (injectedSpotId !== undefined) {
      request = request.set(HEADER_NAME, spotId || injectedSpotId);
    }
    return { request };
  };
}

export default { createRequestInterceptor };
